import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayError from 'shared/utils/displayError'

interface addAllFilterValuesProps {
  filterId: number
  permissionId: number
  recentOnly?: boolean
}

const addAllFilterValues = async (props: addAllFilterValuesProps) => {

  const formData = {
    filter_id: props.filterId,
    permission_id: props.permissionId,
    recentOnly: props?.recentOnly ?? false
  }

  const catchFunc = (err: AxiosError) => {
      displayError({errorMessage: err.message ?? 'An error occurred'})
  }

  const response = await axiosPost(apiUrls.filterValuesToPermissions + '/' + apiUrls.actionAddAll, formData, catchFunc);

  return response.data === true
}

export default addAllFilterValues
